import { axiosInstance } from '../axios';
import type { ApiResponse } from '../../types/common';
import type { DashboardStatsDto } from '../../types/dashboard';

export const dashboardApi = {
  getStats: () =>
    axiosInstance.get<ApiResponse<DashboardStatsDto>>('/v1/product-admin/dashboard'),
};
